import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { translate } from '~l10n/client';
import activity from 'activity';
import rootStudentController from 'root-student-controller';
import RootStudentModel from 'root-student-model';
import _ from 'underscore';

import { StudentWaitView } from 'StudentWaitView';

import { ErrorView } from '../../../shared/error/ErrorView';
import { ActivityPausedView } from '../views/ActivityPausedView';

let model = new RootStudentModel(); // No separate model is needed; just reuse the root model.

function StudentWaitController() {}

StudentWaitController.prototype = _.extend(
  Object.create(Object.getPrototypeOf(rootStudentController)),
  {
    doWait: function () {
      if (!controller.shouldDoWait()) {
        controller.doNextRoute();
      } else {
        controller.renderView();
      }
    },

    renderView: function () {
      ReactDOM.render(
        <ErrorView>
          {activity.isActivityPaused() ? (
            <ActivityPausedView />
          ) : (
            <StudentWaitView
              isTeacherPaced={activity.isTeacherPaced()}
              allQuestionsAnswered={model.allQuestionsAnswered()}
              isStudentFinished={model.isStudentFinished()}
              timerExpired={
                activity.has('student_timer_expired') &&
                activity.get('student_timer_expired') &&
                activity.has('settings') &&
                activity.get('settings').quiz_timer_seconds > 0
              }
            />
          )}
        </ErrorView>,
        document.getElementById('main-content')
      );
    },
  }
);

StudentWaitController.prototype.constructor = StudentWaitController;
let controller = new StudentWaitController();

module.exports = controller;
